import { Box, Flex, Input, Checkbox,Heading,Button, IconButton
} from "@chakra-ui/react"
import {useUpsertParticipantsMutation,useParticipantsQuery,useRolesQuery,
  useUpsertParticipantRoleMutation,useDeleteParticipantRoleMutation,useDeleteParticipantMutation
} from "../app/api"
import {map as m,filter as f, prop as p, not,head,compose as C, fromPairs, 
  groupBy as g, __, path} from "ramda";
import { CloseIcon, AddIcon } from "@chakra-ui/icons";
import { Field, FieldArray, Form, Formik } from "formik";
import { useSelector } from "react-redux";

export const Participants = ({id}) => {
  const {data:participants_query} = useParticipantsQuery({decision_id:id});
  const {data:roles} = useRolesQuery();
  const [upsertParticipants] = useUpsertParticipantsMutation();
  const [deleteParticipant] = useDeleteParticipantMutation();
  const [upsertRole] = useUpsertParticipantRoleMutation();
  const [deleteRole] = useDeleteParticipantRoleMutation();
  const texts = useSelector(path(["ui","ui_texts"]));
  const lang = useSelector(path(["ui","lang"]));
  const participants_map = x => ({...x,roles:fromPairs(x.participant_roles.map(x => [x.role_id, true]))});
  const participant_role_map = C(
    m(C(head,m(C(fromPairs,m(x => [x.role_id,x.id]),p("participant_roles"))))),
    g(p("id"))
  )(participants_query || [])

  const handleSubmit = ({participants}) => {
    C(
      upsertParticipants,
      m(x => ({decision_id:id, email: x.email})),
      f(C(not,p("id"))),
    )(participants);
  }
  const removeParticipant = (x) => {
    deleteParticipant(x)
  }

  const editRole = (participant,role_id,value) => {
    const id = participant_role_map[participant.id][role_id]
    if (value) {
      upsertRole({id,role_id,participant_id:participant.id});}
    else {
      deleteRole(id);
    }
  }

  return <Box mt={5} shadow="xs" bg={"white"} p={5} borderRadius={5}>
    <Heading fontSize='xl'mb={2}>{texts.people}</Heading>
    {(participants_query && roles) ? <Formik 
      initialValues={{participants:m(participants_map,participants_query || [])}} 
      onSubmit={handleSubmit}>
      {({values}) => (
        <Form>
          <FieldArray name="participants">{({ push, remove }) => (<>
            {values?.participants?.map((input, index) => (
            <Flex gap={2} key={index} direction="column" alignItems={"center"}>
                <Field as={Input} id="email" name={`participants.${index}.email`} />
                <Flex>
                  <FieldArray name={`participants.${index}.roles`}>{({ form }) => 
                    (<>{roles?.map(({name,name_eng,id}) => (
                        <Field m={5} mt={0} key={name} as={Checkbox} name={`participants.${index}.roles.${id}`} 
                          direction="column" colorScheme="teal"
                          isChecked={values?.participants?.[index]?.roles?.[id] || false}
                          onChange={(e,a,b) => {
                            form.setFieldValue(`participants.${index}.roles`, 
                            {...values.participants[index].roles,[id]: e.target.checked },false);
                            editRole(values.participants[index],id,e.target.checked);
                          }}
                        >{lang === "en" ? name_eng : name}
                      </Field>) )}</>)}
                  </FieldArray>
                  <IconButton icon={<CloseIcon />} colorScheme="teal"  ml={5}  size="xs"  
                    onClick={(a) => {removeParticipant(values.participants[index]);remove(index)}}/>
                </Flex>
            </Flex>))}
            <Flex mt={2} gap={2}>
              <IconButton type="button" icon={<AddIcon />} size="md" 
                colorScheme="teal" onClick={() => {
                push({})}}>
                {texts.add_people}
              </IconButton>
              <Button size="md" colorScheme="teal" type="submit">
              {texts.save}
              </Button>
            </Flex>
          </>)}
          </FieldArray>
        </Form>)}        
    </Formik> : ""}
  </Box>

}

